"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  FloppyDisk2: ['floppy-disk-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H4.5A2,2,0,0,0,3,.587L.586,3A2.009,2.009,0,0,0,0,4.415V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM5.7,7.5A1.238,1.238,0,0,1,4.5,6.228V2.251A.25.25,0,0,1,4.75,2h14.5a.249.249,0,0,1,.25.25V6.228A1.238,1.238,0,0,1,18.3,7.5ZM15.5,13A3.5,3.5,0,1,1,12,9.5,3.5,3.5,0,0,1,15.5,13Zm-11,6.5a1.113,1.113,0,0,1,1.2-1H18.3a1.113,1.113,0,0,1,1.2,1v2.25a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25Z', 'M7.000 2.501 L9.000 2.501 L9.000 6.501 L7.000 6.501 Z']],
  FloppyDisk1: ['floppy-disk-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H4.414A1.986,1.986,0,0,0,3,.587L.586,3A2.009,2.009,0,0,0,0,4.415V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM4.75,6a.249.249,0,0,1-.25-.25v-3.5A.25.25,0,0,1,4.75,2h14.5a.251.251,0,0,1,.177.073.255.255,0,0,1,.073.177v3.5a.249.249,0,0,1-.25.25ZM15.5,12.5A3.5,3.5,0,1,1,12,9,3.5,3.5,0,0,1,15.5,12.5Zm-11,7.75A.25.25,0,0,1,4.75,20h14.5a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25Z']],
  FloppyDisk: ['floppy-disk', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.914A1.986,1.986,0,0,0,4.5.587L.586,4.5A2.009,2.009,0,0,0,0,5.915V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM18.5,2a.5.5,0,0,1,.5.5v4A1.5,1.5,0,0,1,17.5,8H7.5A1.5,1.5,0,0,1,6,6.5v-4A.5.5,0,0,1,6.5,2ZM5,22a.5.5,0,0,1-.5-.5v-8A1.5,1.5,0,0,1,6,12H19a1.5,1.5,0,0,1,1.5,1.5v8a.5.5,0,0,1-.5.5Z', 'M15,4.251v1.5a.75.75,0,1,0,1.5,0v-1.5a.75.75,0,1,0-1.5,0Z', 'M7,16.251h6.5a.75.75,0,0,0,0-1.5H7a.75.75,0,0,0,0,1.5Z', 'M7,20.251H18a.75.75,0,0,0,0-1.5H7a.75.75,0,0,0,0,1.5Z']],
  FloppyDisk3: ['floppy-disk-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.5A11.5,11.5,0,1,0,.5,12,11.5,11.5,0,0,0,12,23.5Zm2.846-7.875a7.673,7.673,0,0,0,1.717-2.972.5.5,0,0,1,.81-.238L20.3,14.984a.5.5,0,0,1,.143.535,4.775,4.775,0,0,1-1.172,2.031.5.5,0,0,1-.536.144l-3.684-1.247a.5.5,0,0,1-.2-.821Zm-4.411-12.3a.5.5,0,0,1,.392-.393,4.777,4.777,0,0,1,2.346,0,.5.5,0,0,1,.392.393l.763,3.814a.5.5,0,0,1-.612.583,7.677,7.677,0,0,0-3.432,0,.5.5,0,0,1-.612-.584ZM12,9.5A2.5,2.5,0,1,1,9.5,12,2.5,2.5,0,0,1,12,9.5ZM3.7,14.983l2.921-2.567a.5.5,0,0,1,.811.238,7.671,7.671,0,0,0,1.716,2.972.5.5,0,0,1-.2.821L5.267,17.694a.5.5,0,0,1-.535-.144,4.768,4.768,0,0,1-1.173-2.031A.5.5,0,0,1,3.7,14.983Z']]
};
exports["default"] = _default;